{
  "noMoreToday": "There is no more recording later this day.",
  "notYet": "That time has not arrived yet — there is no recording for it.",
  "jumpedTo": "There is no recording at the chosen spot — opened the nearest one, from {{at}}.",
  "fragmentSaved": "Fragment saved: {{file}}",
  "exportFailed": "The export failed.",
  "exportFailedStatus": "The export failed ({{status}}).",
  "notConfigured": "archive not configured",
  "fromCache": "from cache",
  "viaAgent": "through the agent",
  "pickCamera": "Pick a camera",
  "pickCameraHint": "On the left are the organization's cameras. Not every one has an archive: it depends on whether the camera records to its own disk or to a recorder.",
  "unavailable": "The archive is unavailable",
  "pickMoment": "Pick a moment on the timeline",
  "pickMomentHint": "Green marks what was recorded. A click on the timeline plays from that moment.",
  "pickMomentBlind": "This archive provider does not know where recordings exist: click the timeline at a guess — if there is nothing there, the camera will say so.",
  "opening": "Opening the recording… {{seconds}} s",
  "openingHint": "The camera is seeking that moment on its disk. This takes longer than opening a live stream.",
  "notOpened": "The recording did not open",
  "askingCamera": "asking the camera",
  "recordedToday": "{{duration}} recorded that day",
  "scheduleUnknown": "the recording schedule is unknown",
  "selectToExport": "select a fragment on the timeline to export it as a file",
  "exportLimit": "No longer than {{minutes}} minutes at a time",
  "exportUnsupported": "The selected archive provider cannot serve a fragment as a file",
  "exporting": "Exporting…",
  "exportFragment": "Export the fragment",
  "noCameras": "No cameras yet. Add them in the panel of a node of type “camera” on the network map.",
  "blankPicture": "The recording opened, but the camera has not sent a single frame yet. Most often that is the codec: the archive is written from the main stream, and if it is H.265 the browser will not show it (on Windows the HEVC Video Extensions add-on from the Microsoft Store helps, and Safari 17+ works right away). Less often the camera is still seeking on its disk: then the picture appears on its own.",
  "h265Refusal": "The camera's main stream is H.265, and this browser does not decode it. The archive is written from that very main stream, so a substream will not help here, and what is already recorded stays H.265 even if the camera is switched to H.264 (worth doing anyway, for the future). To watch what is already recorded: on Windows install the HEVC Video Extensions add-on from the Microsoft Store — after that H.265 plays in Edge and in Chrome; in Safari 17+ it plays right away.",
  "undecodable": "The browser does not decode the video of this recording.",
  "describeRefusal": "The camera did not serve a recording for that time. Usually that means there is none, or that the channel or the archive provider in the camera settings is wrong, or that the camera is already busy with another disk search. Try a neighboring stretch of the timeline, and if that does not help, check the camera's archive settings.",
  "authRefusal": "The camera rejected the archive credentials. Check the login and the password on the camera node — the recording uses the same ones as the live stream.",
  "startTimeout": "The recording did not start within the allotted time. There may be no archive left for that moment, or the camera is busy with another disk search — try a neighboring stretch of the timeline.",
  "openFailed": "The recording could not be opened.",
  "provider": {
    "hikvisionIsapi": "Hikvision ISAPI",
    "dahuaCgi": "Dahua CGI",
    "rtspReplay": "RTSP replay (ONVIF Profile G)"
  },
  "request": {
    "dahuaNextChunk": "the next chunk of recordings",
    "dahuaCreateSearch": "creating an archive search",
    "dahuaFindByRange": "searching recordings by interval",
    "isapiRecordList": "the ISAPI recording list"
  },
  "duration": {
    "hoursMinutes": "{{hours}} h {{minutes}} min",
    "minutesSeconds": "{{minutes}} min {{seconds}} s",
    "seconds": "{{seconds}} s"
  },
  "timeline": {
    "label": "Archive timeline",
    "hint": "click to play from that moment, drag to select a fragment, wheel to zoom",
    "notPlaying": "playback is not running",
    "unavailable": "the timeline is unavailable"
  },
  "zoom": {
    "title": "Timeline scale",
    "back": "Move the window back",
    "forward": "Move the window forward",
    "in": "Zoom in",
    "out": "Zoom out",
    "wholeDay": "Show the whole day",
    "day": "day"
  },
  "controls": {
    "label": "Playback controls",
    "previous": "To the previous fragment",
    "previousTitle": "To the previous recorded fragment",
    "next": "To the next fragment",
    "nextTitle": "To the next recorded fragment",
    "back": "Back {{seconds}} seconds",
    "backShort": "Back {{seconds}} s",
    "forward": "Forward {{seconds}} seconds",
    "forwardShort": "Forward {{seconds}} s",
    "play": "Play",
    "pause": "Pause",
    "stop": "Stop",
    "stopTitle": "Stop playback and release the camera",
    "noAudio": "recorded without sound",
    "noAudioHint": "The camera recorded no sound: the microphone is off in its settings, or there is none",
    "speed": "Speed",
    "speedAria": "Playback speed",
    "onCamera": "on the camera",
    "inBrowser": "in the browser"
  },
  "settings": {
    "notConfigured": "not configured — recordings are invisible",
    "intro": "The archive is requested from the camera itself, its own way. The login and the password are the same as for the stream — the RTSP credential attached to the node.",
    "httpPort": "HTTP port",
    "schemeAria": "Protocol of the camera web interface",
    "portHint": "the web interface, not RTSP — on some cameras it is not 80",
    "track": "Track",
    "trackHint": "101 is the main stream of the first channel, 102 is its substream",
    "channel": "Channel",
    "channelHint": "1 is the camera itself; on a recorder it is the channel number",
    "template": "Template",
    "templateHint": "Path of the camera's archive stream. Substitutions: {from}, {to}, {channel}, {track}, {path} — the live stream path.",
    "timeFormat": "Format",
    "epochSeconds": "epoch seconds",
    "cameraClock": "Camera clock",
    "clockHint": "minutes from UTC. A mistake here gives an empty archive for the day you want and a full one for the neighboring day.",
    "none": "none",
    "speedHint": "name of the speed parameter in the stream address, if the camera accepts one. Empty — the browser does the speeding up.",
    "save": "Save the archive settings"
  },
  "noArchive": "no archive",
  "reason": {
    "noProvider": "Camera “{{name}}” has no archive provider selected. Open the camera settings and choose one — Hikvision, Dahua, or RTSP replay.",
    "noAddress": "Node “{{name}}” has no address — there is nowhere to go for the archive.",
    "agentOffline": "The site agent “{{name}}” is not connected, and the camera is only reachable through it. Check the netdeck-agent service.",
    "unavailable": "The archive of camera “{{name}}” is unavailable."
  },
  "warning": {
    "noSpeed": "The camera does not accept a playback speed in the stream address — the recording plays in real time.",
    "tooManyFiles": "The camera returned more than {{limit}} files for this interval — only the beginning is shown. Narrow the interval to see the rest.",
    "tooManyFragments": "The camera returned more than {{limit}} fragments for this interval — only the beginning is shown. Narrow the interval to see the rest.",
    "noTimeline": "This archive provider cannot report where recordings exist: pick the interval by hand. If the camera is a Hikvision or a Dahua, set its provider in the camera settings — the timeline works there."
  },
  "cameraTimeout": "The camera did not answer within {{seconds}} s",
  "day": "Day"
}
